import React from "react";
import NewFeatureLabel from "./NextFeatureLabel";
import IconMC from "../../../components/IconMC";

const CardButton = ({
  icon,
  title,
  description,
  futureFeature = false,
  beta = false,
  isIcon = false,
  disabled = false,
  locked = false,
  lockedBadge = null,
  statusLabel = null,
  statusActive = false
}) => {
  const isInactive = futureFeature || disabled || locked;

  const handleClick = (e) => {
    if (isInactive) {
      e.stopPropagation();
    }
  };

  return (
    <div
      className={`tw-items-center tw-border tw-border-gray-200 tw-rounded-xl tw-px-4 tw-py-3 ${
        !isInactive ? 'tw-cursor-pointer' : locked ? 'tw-cursor-not-allowed' : ''
      } ${locked ? 'tw-bg-gray-50/60' : ''}`}
      style={locked ? undefined : { backgroundColor: '#FFFFFF' }}
      onClick={handleClick}
    >
      <div className="tw-flex tw-flex-row tw-items-center">
        {isIcon ? (
          <div
            className={`tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-[5px] tw-mr-2 ${
              locked ? 'tw-bg-gray-100' : 'tw-bg-blue-50'
            }`}
          >
            <IconMC
              name={icon}
              className={locked ? 'tw-text-gray-400' : 'tw-text-blue-500'}
              size="lg"
            />
          </div>
        ) : (
          <img
            src={icon}
            alt=""
            className={`tw-w-[35px] tw-mr-2.5 ${locked ? 'tw-opacity-40 tw-grayscale' : ''}`}
          />
        )}

        <div className="tw-flex tw-flex-col tw-w-full">
          <div className="tw-flex tw-w-full">
            <div className="tw-flex-grow">
              <div className="tw-flex tw-items-center tw-pb-[2px] tw-gap-2 tw-flex-wrap">
                <span className={`tw-font-semibold ${locked ? 'tw-text-gray-500' : 'tw-text-gray-950'}`}>
                  {title}
                </span>
                {locked && lockedBadge && (
                  <span className="tw-px-1.5 tw-py-0.5 tw-bg-orange-50 tw-text-orange-600 tw-text-[10px] tw-font-semibold tw-rounded tw-whitespace-nowrap">
                    {lockedBadge}
                  </span>
                )}
                {!locked && statusLabel && (
                  <span className={`tw-rounded-full tw-px-2 tw-py-[2px] tw-text-2xs tw-font-medium ${
                    statusActive
                      ? 'tw-bg-green-50 tw-text-green-600'
                      : 'tw-bg-red-50 tw-text-red-600'
                  }`}>
                    {statusLabel}
                  </span>
                )}
                {!locked && futureFeature && <NewFeatureLabel />}
                {!locked && beta && (
                  <span className="tw-bg-violet-50 tw-text-violet-600 tw-rounded-full tw-px-2 tw-py-[2px] tw-text-2xs tw-font-medium">
                    Beta
                  </span>
                )}
              </div>
              {description && (
                <div className={`tw-font-regular tw-text-xs tw-w-[90%] ${
                  locked ? 'tw-text-gray-400' : 'tw-text-gray-950'
                }`}
                >
                  {description}
                </div>
              )}
            </div>
            {!isInactive && (
              <div className="tw-flex tw-items-center">
                <IconMC
                  name="arrow-ios-downward-outline"
                  size="base"
                  className="tw-text-xl tw-text-gray-700 tw-rotate-[270deg]"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardButton;
